class CustomAccordion extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.accordionItems = Array.from(
            this.querySelectorAll(".accordion-item")
        );

        this.accordionItems.forEach((item) => {
            const accordionHeader = item.querySelector(".accordion-header");
            if (accordionHeader) {
                accordionHeader.addEventListener("click", () =>
                    this.toggleAccordion(item)
                );
            }
        });
    }

    toggleAccordion(item) {
        const accordionContent = item.querySelector(".accordion-content");
        if (accordionContent) {
            const isOpen = item.classList.toggle("open");
            accordionContent.style.maxHeight = isOpen
                ? `${accordionContent.scrollHeight + 40}px`
                : null;
        }
    }
}

customElements.define("custom-accordion", CustomAccordion);
